import React from 'react'
import Modal from '../../components/Modal'
import styles from './Withdraw.module.sass'

const SecurityAuthModal = ({
  visible,
  onClose,
  onSubmit,
  emailCode,
  gaCode,
  onEmailCodeChange,
  onGaCodeChange,
}) => {
  const canConfirm = emailCode.trim() && gaCode.trim()

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!canConfirm) return

    onSubmit?.()
  }

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      isClosable
      outerClassName={styles.securityModalOuter}
    >
      <form className={styles.securityModal} onSubmit={handleSubmit}>
        <h2 className={styles.securityTitle}>Security authentication</h2>

        <div className={styles.securityField}>
          <div className={styles.securityInputWrap}>
            <input
              type="text"
              className={styles.securityInput}
              placeholder="E-mail Verification Code"
              value={emailCode}
              onChange={(e) => onEmailCodeChange(e.target.value)}
            />
            <button type="button" className={styles.sendCodeButton}>
              Click to send
            </button>
          </div>
          <p className={styles.securityHint}>
            Enter the code that your email `a.o****@exinitic.com` received
          </p>
        </div>

        <div className={styles.securityField}>
          <div className={styles.securityInputWrap}>
            <input
              type="text"
              className={styles.securityInput}
              placeholder="GA code"
              value={gaCode}
              onChange={(e) => onGaCodeChange(e.target.value)}
            />
          </div>
        </div>

        <button type="button" className={styles.securityHelp}>
          Security item lost?
        </button>

        <div className={styles.confirmActions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`${styles.confirmButton} ${canConfirm ? styles.confirmButtonActive : ''}`}
            disabled={!canConfirm}
          >
            Confirm
          </button>
        </div>
      </form>
    </Modal>
  )
}

export default SecurityAuthModal
